import type { TimeDivision } from '../../types';
import type { AggregationReportNames } from '../services/SiteReportingService/types';

const params = new URLSearchParams(window.location.search);

interface ReportingQueryOptions {
  startDate?: string;
  endDate?: string;
  timeDivider?: TimeDivision;
  serviceLevelReportingType?: AggregationReportNames;
}

const paramsObj: ReportingQueryOptions = (() => {
  const obj: Record<string, string | null> = {};
  for (const val of params.keys()) {
    obj[val] = params.get(val);
  }
  return obj as ReportingQueryOptions;
})();

export const queryOptions = {
  startDate: parseInt(paramsObj.startDate || '0', 10),
  endDate: parseInt(paramsObj.endDate || '0', 10),
  timeDivider: paramsObj.timeDivider,
  serviceLevelReportingType: paramsObj.serviceLevelReportingType,
};
